import { render, staticRenderFns } from "./ForgotYourPassword.vue?vue&type=template&id=bf6ee18c&scoped=true&"
import script from "./ForgotYourPassword.vue?vue&type=script&lang=js&"
export * from "./ForgotYourPassword.vue?vue&type=script&lang=js&"
import style0 from "./ForgotYourPassword.vue?vue&type=style&index=0&id=bf6ee18c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf6ee18c",
  null
  
)

export default component.exports